import { RegisterType } from 'types';

import { Button } from 'components/Button';

import * as S from './Item.styles';

type ItemProps = {
  register?: RegisterType;
  nameEn: string;
  nameIt: string;
  valueEn: string;
  valueIt: string;
  onRemove?: () => void;
};

export function Item(props: ItemProps): React.ReactElement {
  const { register, nameEn, nameIt, valueEn, valueIt, onRemove } = { ...props };

  return (
    <S.Container>
      <S.ItemInput
        motive="m2"
        name={nameEn}
        flag="en"
        defaultValue={valueEn}
        register={register}
      />

      <S.ItemInput
        motive="m2"
        name={nameIt}
        flag="it"
        defaultValue={valueIt}
        register={register}
      />

      <Button motive="primaryBlack" iconLeft="FiTrash2" onClick={onRemove} />
    </S.Container>
  );
}
